import React from 'react';

interface PortalHeadingProps {
  /** A small mono line above the title, e.g. today's date. */
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Right of the title on desktop, under it on phones (e.g. the code entry). */
  aside?: React.ReactNode;
}

/** A portal page title: Plus Jakarta 800 at 32px (26px on phones) over a muted line. */
export function PortalHeading({ eyebrow, title, description, aside }: PortalHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between md:gap-8">
      <div className="flex min-w-0 flex-col gap-1 md:gap-1.5">
        {eyebrow && (
          <p className="mb-1 font-mono text-[10.5px] font-bold uppercase tracking-[0.14em] text-muted-foreground md:text-[11px]">{eyebrow}</p>
        )}
        <h1 className="font-display text-[26px] font-extrabold leading-[1.15] tracking-[-0.04em] text-foreground md:text-[32px] md:leading-[1.1]">
          {title}
        </h1>
        {description && <p className="text-[15px] text-muted-foreground">{description}</p>}
      </div>
      {aside}
    </div>
  );
}

export default PortalHeading;
